import Box from '@mui/material/Box';
import { CustomerDetail } from '../../../../features/users/views/CustomerDetailsTable';
import OpenWindow from '../../../components/OpenWindow/OpenWindow';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import useApplication from '../../../hooks/useApplication.hooks';
import axios, { AxiosResponse } from 'axios';
import TestEmailButton from './TestEmailButton';

type EmailSettingsProps = {
    data: CustomerDetail;
    onChange: (updatedValue: CustomerDetail) => void;
};

type OAuthToken = {
    oAuthKey: string;
};

const GmailSettings = (props: EmailSettingsProps) => {
    const { data, onChange } = props;
    const { isLoading, setIsLoading } = useApplication();

    const handleWindowClose = async () => {
        try {
            // Make the API call
            const response = await fetch(`/api/google/oauth/GetResult?customerSettingsId=${data.id}`);

            // Check if the response is OK (status code 200-299)
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const responseData = await response.json();

            if (responseData) {
                onChange({ ...data, emailAddress: responseData!.oAuthKey });
            }
        } catch (error) {
            console.error('Failed to fetch OAuth token:', error);
            return null;
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <OpenWindow
                title="Authorize with Google"
                onWindowClose={handleWindowClose}
                url={`${window.location.origin}/api/google/oauth/redirect?settingsId=${data.id}`}
            />

            <TextField
                error={data.emailAddressError}
                fullWidth
                label="Email Address"
                placeholder="Email Address"
                size="small"
                type="email"
                value={data.emailAddress}
                disabled={true}
            />

            <TestEmailButton data={data} onUpdate={(updatedData: CustomerDetail) => onChange(updatedData)} />
        </>
    );
};

export default GmailSettings;
